module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img2_m.4dba079de072f38df88902ec715b8849.jpg";